module.exports = __webpack_public_path__ + "media/img/archi-12-c6b83998.png";